import { fromEntries } from './fromEntries';
export const omit = (obj, keys) => {
    return fromEntries(Object.entries(obj).filter(([key]) => !keys.includes(key)));
};
//# sourceMappingURL=omit.js.map
// @zapier/design-system@6.1.0 (fd86aa2ab)
